<div class="mx-auto max-w-(--breakpoint-2xl) px-3">
<div class="w-full">
  <div class="my-10 text-center">
    <h2 class="text-2xl font-medium text-gray-800 dark:text-white/90">
      @if (supplier.id) {
        Edit Supplier
      } @else {
        Add Supplier
      }
    </h2>
  </div>
</div>

<form [formGroup]="form">

  <div class="grid grid-cols-1 xl:grid-cols-2 gap-5 items-start">
    <div class="w-full">

      <div class="mb-3 rounded-2xl w-full border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">

        <div class="px-5 py-4 sm:px-6 sm:py-5">
          <h3 class="text-base font-medium text-gray-800 dark:text-white/90">
            Supplier Information
          </h3>
        </div>
        <div class="p-5 space-y-6 border-t border-gray-100 dark:border-gray-800 sm:p-6">
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-5">
            <div>
              <app-text-input [control]="form.controls.name" [name]="'name'" [placeholder]="'Supplier Name'" [label]="'Name'"></app-text-input>
            </div>

            <div>
              <app-text-input [control]="form.controls.phone" [name]="'phone'" [placeholder]="'+00 123 456 789'" [label]="'Phone Number'"></app-text-input>
            </div>

            <div>
              <app-select [multiple]="true" [createPlaceholder]="'Add new service'" [allowCreate]="true" (optionCreate)="createService($event)" [control]="form.controls.services" [choices]="serviceChoices" [placeholder]="'Select services...'" label="Services"></app-select>
            </div>

            <div class="sm:col-span-2">
              <app-text-input [control]="form.controls.website" [name]="'website'" [placeholder]="'example.com'" [label]="'Website'"></app-text-input>
            </div>

            <div class="sm:col-span-2">
              <app-text-input [control]="form.controls.email" [name]="'email'" [placeholder]="'name@example.com'" [label]="'Email'" [type]="'email'"></app-text-input>
            </div>

            <div class="sm:col-span-2">
              <app-text-input [control]="form.controls.description" [name]="'description'" [placeholder]="'Supplier Description'" [label]="'Description'"></app-text-input>
            </div>

            <div>
              <app-select [control]="form.controls.status" [choices]="statusChoices" label="Status"></app-select>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="w-full">

      <div class="rounded-2xl w-full border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">
        <div class="px-5 py-4 sm:px-6 sm:py-5">
          <h3 class="text-base font-medium text-gray-800 dark:text-white/90">
            Images
          </h3>
        </div>
        <div class="p-5 space-y-6 border-t border-gray-100 dark:border-gray-800 sm:p-6">
          <div class="flex flex-col gap-5">

            <div>
              <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400">
                Image
              </label>
              @if (imageUrl) {
                <img [src]="imageUrl" alt="Selected Image" class="mt-2 w-[300px]">
              } @else {
                @if (supplier.images.length > 0 && supplier.images[0].sm) {
                  <img [src]="supplier.images[0].sm" alt="Existing Image" class="mt-2 w-[300px]">
                }
              }
              <div class="w-full mt-5">
                <input type="file" (change)="onFileChange($event)"
                       class="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full
                       file:border-0 file:text-sm file:font-semibold file:bg-brand-50 file:text-brand-700 hover:file:bg-brand-100">
              </div>
            </div>

          </div>

        </div>
      </div>

    </div>

  </div>


  <div class="mt-8 flex flex-row items-center justify-end gap-3">
    <app-button
      [label]="'Cancel'"
      [icon]="XIcon"
      [style]="'secondary'"
      [disabled]="processing"
      (click)="cancel()"
    ></app-button>

    <app-button
      [label]="'Save & Continue'"
      [icon]="CheckCircleIcon"
      [style]="'secondary'"
      [disabled]="processing || !form.valid || form.pristine"
      (click)="saveAndContinue()"
    ></app-button>

    <app-button
      [label]="'Save'"
      [icon]="CheckCircleIcon"
      [style]="'primary'"
      [disabled]="processing || !form.valid || form.pristine"
      (click)="save()"
    ></app-button>
  </div>

<!--    @if (validationErrors.length > 0) {-->
<!--      <div class="mt-4 p-4 border border-red-500 bg-red-100 text-red-700 rounded-lg">-->
<!--        <h3 class="font-medium">Validation Errors:</h3>-->
<!--        <ul class="list-disc list-inside">-->
<!--          @for (error of validationErrors; track error) {-->
<!--            <li>{{ error }}</li>-->
<!--          }-->
<!--        </ul>-->
<!--      </div>-->
<!--    }-->

</form>
</div>
